const FooterListItemUrl = ({ url, pageSlug, label }) => (
    <li>
        {pageSlug ? (
            <Link to={pageSlug}>{label}</Link>
        ) : (
            <a target="__blank" href={url}>
                {label}
            </a>
        )}
    </li>
)

FooterListItemUrl.propTypes = {
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
}

export default FooterListItemUrl
